export interface ICard {
  brand: string;
  created: string;
  default: boolean;
  exp_month: number;
  exp_year: number;
  id: number;
  last_four: string;
  owner_id: number;
  payment_processor?: IPaymentProcessor;
  stripe_token: string;
  updated: string;
}

export enum EUserCardBrand {
  Visa = 'visa',
  AmericanExpress = 'american express',
  Mastercard = 'mastercard',
  Discover = 'discover',
  DinersClub = 'diners club',
  JSB = 'jcb',
}

interface IPaymentProcessor {
  country: string;
  name: string;
}
